import { useCallback, useEffect } from 'react';
import { useGetMe } from 'src/api/user_api';
import { usePathname } from 'src/hooks/router/use_pathname';
import { useRouter } from 'src/hooks/router/use_router';
import { useSearchParams } from 'src/hooks/router/use_search_params';
import { PATHS } from 'src/routes/paths';
import { isEmpty } from 'src/utils/type_check';

export default function GuestGuard({ children }) {
  const router = useRouter();

  const { user, searchLoading } = useGetMe();

  const searchParams = useSearchParams();

  const curPath = usePathname();

  const returnTo = searchParams.get('returnTo') ?? PATHS.dashboard.root;

  const check = useCallback(() => {
    if (!searchLoading) {
      if (curPath === PATHS.auth.chooseLocation) return;
      else if (!isEmpty(user)) {
        router.replace(returnTo);
      }
    }
  }, [user, searchLoading, returnTo, router, curPath]);

  useEffect(() => {
    check();
  }, [check, searchLoading, user]);

  if (searchLoading) {
    return null;
  }

  return <>{children}</>;
}
